import { render, staticRenderFns } from "./newSparepart.vue?vue&type=template&id=006fd59e"
import script from "./newSparepart.vue?vue&type=script&lang=js"
export * from "./newSparepart.vue?vue&type=script&lang=js"
import style0 from "./newSparepart.vue?vue&type=style&index=0&id=006fd59e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports